import { render } from "./SecretI.vue?vue&type=template&id=2ad38a04&scoped=true"
import script from "./SecretI.vue?vue&type=script&lang=js"
export * from "./SecretI.vue?vue&type=script&lang=js"

import "./SecretI.vue?vue&type=style&index=0&id=2ad38a04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad38a04"]])

export default __exports__